import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { Categories } from "./Categories/Categories";
import { FAndB } from "./F&B/fAndB";
import { Products } from "./Products/Products";
import { SubCategories } from "./SubCategories/SubCategories";
import { Brands } from "./Brands/Brands";
import { Currencies } from "./Currencies/Currencies";
import { Icon } from "@iconify/react";
import { Express } from "./E-Xpress/Express";

export const ProductManagement = () => {
  const query = useQuery();
  const activeTab = query.get("activeTab");
  const subActiveTab = query.get("subActiveTab");
  const navigate = useNavigate();
  useEffect(() => {
    if (!query.get("activeTab")) {
      navigate(`/dedicated/eraman/product-management?activeTab=products`, {
        replace: true,
      });
    }
  }, []);

  const items = [
    {
      label: "Products",
      key: "products",
      children: <Products />,
    },
    {
      label: "Categories",
      key: "categories",
      children: <Categories />,
    },
    {
      label: "Sub Categories",
      key: "subCategories",
      children: <SubCategories />,
    },
    {
      label: "Product Brand",
      key: "productBrand",
      children: <Brands />,
    },
    {
      label: "F&B",
      key: "fAndB",
      children: (
        <div>
          <FAndB />
        </div>
      ),
    },
    {
      label: "E-Xpress",
      key: "eXpress",
      children: <Express />,
    },
    // {
    //   label: "Currencies",
    //   key: "currencies",
    //   children: <Currencies />,
    // },
  ];

  const handleProductManagement = (activeTab: any, subActiveTab?: any) => {
    if (activeTab === "subCategories") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/product-management/subCategories/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Sub Categories
        </Button>
      );
    } else if (activeTab === "products") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/product-management/products/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Products
        </Button>
      );
    } else if (activeTab === "productBrand") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/product-management/productBrand/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Brands
        </Button>
      );
    } else if (activeTab === "fAndB" && subActiveTab === "fAndBOutlet") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/product-management/food-and-beverages-outlet/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Outlet
        </Button>
      );
    } else if (activeTab === "fAndB" && subActiveTab === "fAndBBrands") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/product-management/food-and-beverages-brand/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Brand
        </Button>
      );
    } else if (activeTab === "fAndB" && subActiveTab === "fAndBCategory") {
      return (
        <Button
          onClick={() => {
            navigate("/dedicated/eraman/product-management/food-and-beverages-category/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Category
        </Button>
      );
    }
  };

  return (
    <ContentWrapper
      title="Product Management"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleProductManagement(activeTab,subActiveTab)}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={items}
        onChange={(activeKey) => navigate(`${window.location.pathname}?activeTab=${activeKey === "fAndB" ? "fAndB&subActiveTab=fAndBContent" : activeKey}`)}
      />
    </ContentWrapper>
  );
};
